import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Briefcase } from "lucide-react";
import { api, fmtWindow } from "../../lib/api";
import { Card, Empty, ServiceIcon, StatusChip, Money } from "../../components/kit";

export default function MyJobs() {
  const [jobs, setJobs] = useState(null);
  const nav = useNavigate();
  useEffect(() => {
    api.get("/my/jobs").then(({ data }) => setJobs(data)).catch(() => setJobs([]));
  }, []);
  if (!jobs) return <div className="h-40 animate-pulse bg-[#141414] rounded-2xl" />;
  const active = jobs.filter((j) => !["completed", "cancelled", "awaiting_review"].includes(j.status));
  const past = jobs.filter((j) => !active.includes(j));
  const List = ({ items }) =>
    items.map((j) => (
      <Card key={j.id} className="flex items-center gap-3 cursor-pointer hover:border-[#333]" onClick={() => nav(`/s/jobs/${j.id}`)} data-testid="my-job-card">
        <ServiceIcon k={j.service_key} />
        <div className="flex-1 min-w-0">
          <div className="font-medium truncate">{j.service_name} · {j.vehicle_label}</div>
          <div className="text-xs text-neutral-500">{fmtWindow(j.window_start, j.window_end)} · {j.area.city} {j.area.zip}</div>
        </div>
        <div className="text-right space-y-1">
          <StatusChip status={j.status} />
          <Money v={j.payout} green className="block text-sm" />
        </div>
      </Card>
    ));
  return (
    <div className="space-y-3 fade-in">
      <h1 className="font-head text-3xl uppercase font-bold">My jobs</h1>
      {!jobs.length && <Empty icon={Briefcase} title="No assigned jobs" text="Accept an offer to see it here." />}
      <List items={active} />
      {past.length > 0 && <div className="text-xs uppercase tracking-wider text-neutral-500 pt-4">Submitted & past</div>}
      <List items={past} />
    </div>
  );
}
